import * as React from 'react';
import { Link, Icon } from '@fluentui/react';
import Color from '../../../core/libraries/Color';
import { RootState } from '../../../store/store';
import { connect } from 'react-redux';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import RbButton, { ButtonSize, ButtonType } from '../../../bosch-react/components/button/RbButton';
import { IUserProfile } from '../../Auth/types';
import Constants from '../../../core/libraries/Constants';
import { removeAliasDomain } from '../../../utils/converter';

interface INonRnDUserProps {
    userProfile: IUserProfile | undefined,
}

class NonRnDUser extends React.Component<INonRnDUserProps, any> {
    constructor(props: INonRnDUserProps) {
        super(props);
        this.state = {
            id: 0,
            mode: 'view',
        }
        this.openCommunityLink = this.openCommunityLink.bind(this);
    }

    componentDidMount(): void {
    }

    openCommunityLink() {
        window.open("https://connect.bosch.com/communities/community/feber/", "_blank");
    }

    render() {
        const emailBody = "Dear CI-Hotline, %0D%0A %0D%0A"
            + "Service Group: oneIDM, %0D%0A %0D%0A"
            + "Please help grant the FEBER idm role \"" + Constants.IDM_GROUPS.RND_USER + "\" to my account. %0D%0A"
            + "Reason: Access to FEBER research and development reports. %0D%0A %0D%0A"
            + "My NTID is " + removeAliasDomain(this.props.userProfile?.loginName ?? "") + " %0D%0A %0D%0A"
            + "Best Regards, %0D%0A"
            + this.props.userProfile?.name;

        const emailLink = "mailto:ITServiceDesk@bosch.com?"
            + "subject=Request for IDM Role \"" + Constants.IDM_GROUPS.RND_USER + "\""
            + "&body=" + emailBody;

        return (
            <div className="ms-Grid" style={{ 
                minHeight: '65vh', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" style={{ textAlign: 'center' }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '60px 40px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            maxWidth: '700px',
                            margin: '0 auto'
                        }}>
                            {/* Icon */}
                            <div style={{ marginBottom: '30px' }}>
                                <Icon 
                                    iconName="BlockedSite" 
                                    style={{ 
                                        fontSize: '64px', 
                                        color: '#d13438',
                                        marginBottom: '20px'
                                    }} 
                                />
                            </div>

                            {/* Main Title */}
                            <div style={{ marginBottom: '24px' }}>
                                <RbLabel style={{ 
                                    fontSize: '28px', 
                                    fontWeight: '600',
                                    color: '#323130',
                                    lineHeight: '1.3'
                                }}>
                                    Access Restricted
                                </RbLabel>
                            </div>

                            {/* Subtitle */}
                            <div style={{ marginBottom: '32px' }}>
                                <RbLabel style={{ 
                                    fontSize: '20px',
                                    color: '#d13438',
                                    fontWeight: '500'
                                }}>
                                    You are not an R&D user
                                </RbLabel>
                            </div>

                            {/* Main Message */}
                            <div style={{ marginBottom: '32px', textAlign: 'left' }}>
                                <RbLabel style={{ 
                                    fontSize: '16px',
                                    color: '#605e5c',
                                    lineHeight: '1.6',
                                    display: 'block',
                                    marginBottom: '20px'
                                }}>
                                    You are trying to access an R&D FEBER Report.
                                </RbLabel>
                                <RbLabel style={{ 
                                    fontSize: '16px',
                                    color: '#605e5c',
                                    lineHeight: '1.6',
                                    display: 'block'
                                }}>
                                    To access R&D Reports in FEBER, the role "<strong>{Constants.IDM_GROUPS.RND_USER}</strong>" is required.
                                </RbLabel>
                            </div>

                            {/* Instructions */}
                            <div style={{ 
                                marginBottom: '40px',
                                padding: '24px',
                                backgroundColor: '#fef7e6',
                                borderRadius: '8px',
                                border: '2px solid #ffb900',
                                textAlign: 'left'
                            }}>
                                <div style={{ marginBottom: '16px' }}>
                                    <Icon 
                                        iconName="Info" 
                                        style={{ 
                                            fontSize: '16px', 
                                            color: '#ffb900',
                                            marginRight: '8px'
                                        }} 
                                    />
                                    <RbLabel style={{ 
                                        fontSize: '16px',
                                        color: '#323130',
                                        fontWeight: '600',
                                        display: 'inline'
                                    }}>
                                        How to get access:
                                    </RbLabel>
                                </div>
                                <RbLabel style={{ 
                                    fontSize: '15px',
                                    color: '#605e5c',
                                    lineHeight: '1.5',
                                    display: 'block'
                                }}>
                                    Send an email to your IdM-Administrator or contact the CI-Hotline to request the required role assignment for your user account.
                                </RbLabel>
                            </div>

                            {/* Action Buttons */}
                            <div style={{ 
                                display: 'flex', 
                                gap: '16px', 
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                marginBottom: '32px'
                            }}>
                                <a href={emailLink} style={{ textDecoration: 'none' }}>
                                    <RbButton 
                                        label="Contact CI-Hotline" 
                                        size={ButtonSize.Standard}
                                        style={{
                                            minWidth: '180px',
                                            backgroundColor: Color.BLUE,
                                            borderColor: Color.BLUE
                                        }}
                                    />
                                </a>
                                <RbButton 
                                    type={ButtonType.Secondary}
                                    label="Visit FEBER Community" 
                                    size={ButtonSize.Standard}
                                    onClick={this.openCommunityLink}
                                    style={{
                                        minWidth: '180px'
                                    }}
                                />
                            </div>

                            {/* Additional Info */}
                            <div style={{ 
                                padding: '20px',
                                backgroundColor: '#f3f2f1',
                                borderRadius: '8px',
                                border: `2px solid ${Color.BLUE}20`,
                                textAlign: 'left'
                            }}>
                                <RbLabel style={{ 
                                    fontSize: '14px',
                                    color: '#605e5c',
                                    lineHeight: '1.5',
                                    display: 'block',
                                    marginBottom: '8px'
                                }}>
                                    <strong>Your NTID:</strong> {removeAliasDomain(this.props.userProfile?.loginName ?? "")}
                                </RbLabel>
                                <RbLabel style={{ 
                                    fontSize: '14px',
                                    color: '#605e5c',
                                    lineHeight: '1.5'
                                }}>
                                    For further information regarding FEBER, please visit the FEBER Community in Bosch Connect.
                                </RbLabel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
});

export default connect(mapStateToProps)(NonRnDUser);